// extracted by mini-css-extract-plugin
export default {"image":"H0-z","loaded":"I0-z"};